import { render, staticRenderFns } from "./SpecimenOpt.vue?vue&type=template&id=b70fdd8c&scoped=true"
import script from "./SpecimenOpt.vue?vue&type=script&lang=js"
export * from "./SpecimenOpt.vue?vue&type=script&lang=js"
import style0 from "./SpecimenOpt.vue?vue&type=style&index=0&id=b70fdd8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70fdd8c",
  null
  
)

export default component.exports